import { defineComponent as _defineComponent } from 'vue'
import useStore from '@/utils/store/common';
import PermissionsList from '@/views/UserRole/components/Right/components/PermissionsList/PermissionsList.vue';
import { computed, ref, watch } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'Modal',
  props: {
  display: {
    type: Boolean,
    default: false
  }
},
  emits: ['cancel'],
  setup(__props, { emit }) {

const props = __props;



const display = computed(() => props.display);



const store = useStore();

const getPermissionsFeatures = computed(() => store.getters['userRoles/getPermissionsFeatures']);

const getError = computed(() => store.getters['userRoles/getError']);

const getTranslatedError = computed(() => {
  const err = getError.value;
  if (err === 'This user role already exists, please enter a different role name.') {
    return 'access.user_role.error.duplicate';
  }
  if (err === 'This user role name contains forbidden characters, please use only letters, digits, dot or dash.') {
    return 'access.user_role.error.forbidden';
  }
  return 'device.list.item.unknow';
});

let role: {displayName: string, permissions: string[]} = {
  displayName: '',
  permissions: []
};

const displayName = ref('');

const permissions = ref([] as string[]);

function reset() {
  displayName.value = '';
  permissions.value = [];
  role = {
    displayName: '',
    permissions: []
  };
}

function handleAdd() {
  const data = {
    displayName: displayName.value,
    permissions: permissions.value
  };

  store.dispatch('userRoles/addUserRoleWithPermissions', data);
  reset();
}

function handleCancel() {
  reset();
  emit('cancel', false);

  store.dispatch('userRoles/setError', undefined);
}

function handleUpdate(event: string[]) {
  permissions.value = event;
}

watch(
  () => displayName,
  () => {
    store.dispatch('userRoles/setError', undefined);
  },
  {
    immediate: true
  }
);


return { __sfc: true,props, display, emit, store, getPermissionsFeatures, getError, getTranslatedError, role, displayName, permissions, reset, handleAdd, handleCancel, handleUpdate, PermissionsList }
}

})